declare var dataLayer: any;

export default function DataLayerEvents(selector: string): any {
    const container: HTMLElement = document.querySelector(selector);
    if(container != null) {
        const datalayerSelectors = container.querySelectorAll("*[data-datalayer-event]");
        
        if (datalayerSelectors.length > 0) {
            datalayerSelectors.forEach((datalayerSelector) => {
                const datalayerData = datalayerSelector.dataset
                if (datalayerData.datalayerEvent === 'click') {
                    datalayerSelector.addEventListener('click', (e) => {
                        const params = {};
                        for(const data in datalayerSelector.dataset) {
                            if(data.startsWith('datalayerParam')) {
                                let paramName = data.replace('datalayerParam', '');
                                paramName = paramName[0].toLowerCase() + paramName.slice(1);
                                params[paramName] = datalayerSelector.dataset[data];
                            }
                        }
                        dataLayer.push(params);
                    });
                }
            });
        }
    }
}